module.exports = __webpack_public_path__ + "static/media/QueueApp-min.67b719c5.png";